import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { installPerfDiagnostics } from "./lib/perf-diagnostics";

// No-op unless ?perf-debug=1 or localStorage.PERF_DEBUG === "1".
installPerfDiagnostics();

createRoot(document.getElementById("root")!).render(<App />);

// Real-User Web Vitals — defer to idle so it never competes with LCP.
const idle = (cb: () => void) =>
  (window as any).requestIdleCallback?.(cb, { timeout: 4000 }) ??
  window.setTimeout(cb, 1500);

idle(async () => {
  try {
    const { installWebVitals } = await import("./lib/webVitals");
    installWebVitals();
    const { trackVisit } = await import("./lib/trafficSource");
    trackVisit();
  } catch {
    /* noop */
  }
});
